import { basicApi } from './common'

export default {
  ...basicApi('billing/invoice'),
}
